import { AlertCircle, Button, Icon } from "@dust-tt/sparkle";

// Crash fallback: rendered when the React tree (possibly including the i18n
// provider) already threw, so the copy is hardcoded Korean-first with an
// English line alongside instead of going through react-i18next.
export function GlobalErrorFallback() {
  return (
    <div className="flex h-dvh items-center justify-center">
      <div className="flex flex-col gap-3 text-center">
        <div className="flex flex-col items-center">
          <Icon visual={AlertCircle} size="lg" className="text-warning-400" />
          <p className="heading-xl text-foreground">문제가 발생했습니다</p>
          <p className="copy-sm text-muted-foreground">
            예상치 못한 오류가 발생했습니다. 다시 시도해 주세요.
          </p>
          <p className="copy-sm text-muted-foreground">
            Something went wrong. An unexpected error occurred — please try
            again.
          </p>
        </div>
        <div>
          <Button
            variant="outline"
            label="다시 시도 (Try again)"
            onClick={() => window.location.reload()}
          />
        </div>
      </div>
    </div>
  );
}
